import React, { useState, useEffect } from 'react'
import ImgGoBack from 'resources/images/app/picto-retour-haut-page.svg'
import Utils from 'constants/config'
import { Button } from '@airbus/components-react/components'
import { ArrowUpward } from '@mui/icons-material'

const STYLE_FOR_SCROLL_WINDOW = {
  position: 'fixed',
  right: '1.8vw',
  bottom: '9ex',
  zIndex: '999',
}
const STYLE_FOR_SCROLL_MODAL = {
  float: 'right',
  position: 'sticky',
  right: '1.8vw',
  bottom: '9ex',
  zIndex: '9999',
}

// Display the GoToTop button only once scrolling has started up a little bit
const GoToTop = (props) => {
  // Component of the DOM which a scroll-event listener is added to in order to decide when to show-up the go-to-top button
  const idComponentForScroll = props.idComponentForScroll

  const [styles, setStyles] = useState(idComponentForScroll == '' ? STYLE_FOR_SCROLL_WINDOW : STYLE_FOR_SCROLL_MODAL)
  const [isButtonVisible, setIsButtonVisible] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      let domObject = window
      if (idComponentForScroll != '') {
        domObject = document.getElementById(idComponentForScroll)
      }
      // Add scroll-idComponentForScroll manager in order to keep page's footer at the very bottom and show/hide GoToTop button
      domObject?.addEventListener('scroll', handleScroll, { passive: true })

      return () => {
        domObject?.removeEventListener('scroll', handleScroll)
      }
    }, 1000)
  }, [])

  // Mechanism for displaying the GoToTop button
  const handleScroll = (evt) => {
    // Button Go To Top visible after a short scrolling
    let posY
    if (idComponentForScroll == '') {
      posY = window.pageYOffset
    } else {
      posY = evt.target.scrollTop
    }
    setIsButtonVisible(posY > Utils.SCROLL_MIN_Y_TO_SHOW_GOTOTOP)
  }

  // Scroll back to top on button click
  const handleClickScrollToTop = () => {
    if (idComponentForScroll == '') {
      window.scroll({ top: 0, behavior: 'smooth' })
    } else {
      document.getElementById(idComponentForScroll)?.scroll({ top: 0, behavior: 'smooth' })
    }
  }

  useEffect(() => {
    let extStyles = JSON.parse(JSON.stringify(styles))
    extStyles['visibility'] = isButtonVisible ? 'visible' : 'hidden'
    setStyles(extStyles)
  }, [isButtonVisible])

  return (
    <div style={styles}>
      <Button size='xlarge' variant='ghost' style={{ padding: '0' }} onClick={handleClickScrollToTop}>
        <ArrowUpward />
      </Button>
    </div>
  )
}

export default GoToTop
